module.exports = __webpack_public_path__ + "img/upgrade-to-premium.277421c0.svg";